import styles from './styles.module.css';
import Image from "@/shared/components/Image/new";

const NotasDeAutor = ({ data }) => {
    const clipping = '3_2_300x200';
    return (
        <>
            <div className={` ${styles['notas-container']}`}>
                {data &&
                    data.map((element, id) => {
                        const { url, title } = element;

                        return (
                            <div className={`${styles['nota-container']}`} key={element + id}>
                                <div className={`${styles['nota-img-container']}`}>
                                    <a href={url}>
                                        <Image
                                          element={element} 
                                          clipping={clipping}
                                          priority={id === 0 }
                                        />
                                    </a>
                                </div>
                                <div className={`${styles['nota-texto-container']}`}>
                                    <div className={`${styles['titulo']}`}>
                                        <a href={url}>{title}</a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </>
    );
};

export default NotasDeAutor;
